(function () {
  angular.module('lif.controllers').controller('meetingsFileBlockController', meetingsFileBlockController);
  meetingsFileBlockController.$inject = ['$scope', '$rootScope', '$timeout', '$window', 'formService', 'meetingsFileBootstrap', 'userService', 'constants'];

  function meetingsFileBlockController($scope, $rootScope, $timeout, $window, formService, meetingsFileBootstrap, userService, constants) {
    var vm = this;
    vm.showAddFileInformation = false;
    vm.isBusy = false;
    vm.creatingFolder = false;
    vm.folders = meetingsFileBootstrap.folders;
    vm.showButtons = false;
    vm.deletingFile = false;
    vm.isEditable = meetingsFileBootstrap.isEditable === 'True';
    vm.maximumAmountOfFoldersToShow = 100;

    var getFolderModalName = function getFolderModalName() {
      return "#folderModal-" + vm.baseFolder;
    };

    var getRemoveItemModalName = function getRemoveItemModalName() {
      return "#removeItemModal-" + vm.baseFolder;
    };

    vm.openFile = function (file) {
      $window.open(file.Url, "_blank");
    };

    vm.getFileTypeIcon = function (fileName) {
      return fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase() + '.png';
    };

    vm.addFile = function () {
      vm.showAddFileInformation = !vm.showAddFileInformation;
      $timeout(function () {
        vm.showButtons = !vm.showButtons;
        window.resizeLeftNavbar();
      }, 200);
    };

    vm.showFolder = function (id) {
      if ($scope.toggle === id) {
        $scope.toggle = "";
      } else {
        $scope.toggle = id;
      }
    };

    vm.showAddFolderModal = function () {
      $scope.folderToRemove = {};
      $(getFolderModalName()).modal("show");
    };

    vm.createFolder = function (folderName) {
      vm.creatingFolder = true;
      formService.createFolder(folderName, parseInt(vm.baseFolder), meetingsFileBootstrap.folderUrl).then(function (contentId) {
        $(getFolderModalName()).modal("hide");
        vm.folders.unshift({
          Id: contentId,
          Name: folderName
        });
        vm.creatingFolder = false;
        vm.showAddFileInformation = false;
        vm.showButtons = false;
        $scope.inputFolderName = undefined;
      }, function () {
        //error
        vm.creatingFolder = false;
        vm.showAddFileInformation = false;
        vm.showButtons = false;
        $scope.inputFolderName = undefined;
      });
    };

    vm.showRemoveFileModal = function (file) {
      $scope.fileToRemove = file;
      $(getRemoveItemModalName()).modal("show");
    };

    vm.showRemoveFolderModal = function (folder) {
      $scope.folderToRemove = folder;
      $(getFolderModalName()).modal("show");
    };

    vm.removeFolder = function (folder) {
      vm.deletingFolder = true;
      formService.deleteFolder(meetingsFileBootstrap.folderRemoveUrl, folder.Id).then(function (result) {
        var counter = 0;
        vm.folders.forEach(function (f) {
          if (f.Name === folder.Name) {
            vm.folders.splice(counter, 1);
          } else {
            counter++;
          }
        });
        $(getFolderModalName()).modal("hide");
        vm.deletingFolder = false;
        $scope.folderToRemove = {};
      }, function () {
        //error
        $(getFolderModalName()).modal("hide");
        vm.deletingFolder = false;
        $scope.folderToRemove = {};
      });
    };

    vm.removeFile = function (file) {
      vm.deletingFile = true;
      formService.deleteFile(meetingsFileBootstrap.deleteUrl, file.ContentId).then(function (result) {
        var counter = 0;
        vm.folders.forEach(function (folder) {
          counter = 0;
          folder.Files.forEach(function (f) {
            if (f.Title === file.Title) {
              folder.Files.splice(counter, 1);
              var event = {
                Date: new Date().toJSON().slice(0, 10),
                Message: "Tog bort " + f.Title + " från " + folder.Name,
                User: userService.getLoggedInUser().name,
                Id: undefined,
                GroupEventType: constants.GroupEventType.MeetingsFile,
                Action: constants.Action.Delete
              };
              $rootScope.$broadcast('groupEvent', event);
            } else {
              counter++;
            }
          });
        });
        $(getRemoveItemModalName()).modal("hide");
        vm.deletingFile = false;
        $scope.fileToRemove = {};
      }, function () {
        //error
        $(getRemoveItemModalName()).modal("hide");
        vm.deletingFile = false;
        $scope.fileToRemove = {};
      });
    };

    var startingFoldersAmount = undefined;

    vm.showMoreFolders = function () {
      if (startingFoldersAmount === undefined) {
        startingFoldersAmount = vm.numberOfFoldersToShow;
      }

      if (vm.numberOfFoldersToShow === startingFoldersAmount) {
        vm.numberOfFoldersToShow = vm.maximumAmountOfFoldersToShow;
      } else {
        vm.numberOfFoldersToShow = startingFoldersAmount;
      }
    };

    $scope.$watch('files', function () {
      if ($scope.files !== undefined && $scope.files !== null && $scope.files.length > 0) {
        vm.isBusy = true;
        var uploadValues = {
          url: meetingsFileBootstrap.url,
          folder: $scope.selectedFolder.Id
        };
        formService.uploadFiles($scope.files, uploadValues.url, uploadValues.folder).then(function (results) {
          vm.isBusy = false;
          vm.showAddFileInformation = false;
          vm.showButtons = false;
          vm.folders.forEach(function (f) {
            if (f.Id === $scope.selectedFolder.Id) {
              results.forEach(function (r) {
                if (f.Files === undefined) {
                  f.Files = [];
                }

                f.Files.unshift({
                  Title: r.FileName,
                  ImageName: r.ImageName,
                  Date: r.Date,
                  ContentId: r.ContentId,
                  Url: r.Url
                });
                var event = {
                  Date: new Date().toJSON().slice(0, 10),
                  Message: "Lade till " + r.FileName + " i " + f.Name,
                  User: userService.getLoggedInUser().name,
                  Id: undefined,
                  GroupEventType: constants.GroupEventType.MeetingsFile,
                  Action: constants.Action.Add
                };
                $rootScope.$broadcast('groupEvent', event);
              });
            }
          });
        }, function () {
          //error
          vm.isBusy = false;
        });
      }
    });
  }
})();